import { render, staticRenderFns } from "./Project-Home.vue?vue&type=template&id=707bc587&scoped=true"
import script from "./Project-Home.vue?vue&type=script&lang=js"
export * from "./Project-Home.vue?vue&type=script&lang=js"
import style0 from "./Project-Home.vue?vue&type=style&index=0&id=707bc587&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707bc587",
  null
  
)

export default component.exports